export default "__VITE_ASSET__865d1a4d__"